import React, { useState, useEffect } from 'react';
import { Row } from '@amzn/atoz-web/Row';
import { Text } from '@amzn/atoz-web/Text';
import { Button, ButtonVariant } from '@amzn/atoz-web/Button';
import { WEEKLY_SCHEDULE_HEADER, WEEK_ROW_NAV_NEXT, WEEK_ROW_NAV_PREV } from '../testids.consts';
import { IconChevronLeft, IconChevronRight, IconSize } from '@amzn/atoz-web/Icons';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { HeaderDimensions } from '../dimensions.consts';
import { getTimeRangeDurationText } from '../utils';
export var Header = function (_a) {
    var updateDateAction = _a.updateDateAction, weekRange = _a.weekRange, nextWeekAriaLabel = _a.nextWeekAriaLabel, prevWeekAriaLabel = _a.prevWeekAriaLabel;
    var navigateToNextWeek = function () {
        if (!weekRange)
            return;
        updateDateAction(weekRange.end.plus({ day: 1 }));
    };
    var navigateToPrevWeek = function () {
        if (!weekRange)
            return;
        updateDateAction(weekRange.start.minus({ day: 1 }));
    };
    var _b = useState(''), weekDurationText = _b[0], setWeekDurationText = _b[1];
    useEffect(function () {
        setWeekDurationText(getTimeRangeDurationText(weekRange));
    }, [weekRange]);
    return (React.createElement(HeaderWrapper, { dataTestId: WEEKLY_SCHEDULE_HEADER },
        React.createElement(Text, { fontSize: 'T400', role: "heading", "aria-level": 2 }, weekDurationText),
        React.createElement(Row, { gridGap: "S300" },
            React.createElement(Button, { "data-testid": WEEK_ROW_NAV_PREV, onClick: navigateToPrevWeek, "aria-label": prevWeekAriaLabel, icon: React.createElement(IconChevronLeft, { color: 'primary70', size: IconSize.Small }), variant: ButtonVariant.Tertiary }),
            React.createElement(Button, { "data-testid": WEEK_ROW_NAV_NEXT, onClick: navigateToNextWeek, "aria-label": nextWeekAriaLabel, icon: React.createElement(IconChevronRight, { color: 'primary70', size: IconSize.Small }), variant: ButtonVariant.Tertiary }))));
};
var HeaderWrapper = styledWithTheme(Row)(function (_a) {
    var theme = _a.theme;
    var container = HeaderDimensions.container;
    return "\n        align-items: center;\n        justify-content: space-between;\n        @media (max-width: ".concat(theme.selectors.breakpoint('s').max, "px) {\n            padding-top: ").concat(container.portrait.paddingTop, ";\n        }\n    ");
});
